export default "__VITE_ASSET__22hKn804__"